import React, { useState } from "react";
import "../styles/components/tableauCatalogue.css";
import produits from "../assets/ProductContent/data/data.js";

const TableLiposome = ({ data }) => {
    return (
        <div className="table-container">
            <table className="table">
                <thead>
                    <tr>
                        <th key={1} className="th left">
                            {"NOM"}
                        </th>
                        <th key={2} className="th left">
                            {"ACTIONS"}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, rowIndex) => (
                        <tr key={rowIndex} className="tr left" onClick={() => window.location.href = row["url"]}>
                            <td key={1} className="td">
                                {row["nom"]}
                            </td>
                            <td key={2} className="td left">
                                {row.subtitle}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};


function filterProductsSearch(query, what) {
    return what.filter((produit) => {

        return (
            produit.nom.toLowerCase().includes(query.toLowerCase())
        );
    });
}

function filterProducts(key, what) {
    return produits.filter((produit) => produit[key] === what);
}

export default function TabNiosomeProduct() {
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const productsPerPage = 10;

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1);
    };


    const filteredProducts = filterProductsSearch(searchQuery, filterProducts("type", "niosomeProduct"));
    const indexOfLastProduct = currentPage * productsPerPage;
    const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
    const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);

    const nextPage = () => {
        if (currentPage < Math.ceil(filteredProducts.length / productsPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    return (
        <div className="catalogue-container">
            <div className="tc-head">
                <h1 className="title">finished products catalogue</h1>
                <div className="tc-recherche">
                    <p className="tc-p-recherche">Search : </p>
                    <input
                        type="text"
                        className="search-bar"
                        placeholder="Name"
                        value={searchQuery}
                        onChange={handleSearchChange}
                    />
                </div>
            </div>

            <TableLiposome data={currentProducts} />

            <div className="pagination">
                <button
                    className="pagination-btn"
                    onClick={prevPage}
                    disabled={currentPage === 1}
                >
                    ←
                </button>
                <span className="pagination-span">
                    {currentPage} / {Math.ceil(filteredProducts.length / productsPerPage)}
                </span>
                <button
                    className="pagination-btn"
                    onClick={nextPage}
                    disabled={currentPage === Math.ceil(filteredProducts.length / productsPerPage)}
                >
                    →
                </button>
            </div>

            <div className="tc-pastrouver">
                <h3 className="tc-pastrouver-h3">Looking for a specific ingredient you can't find ?</h3>
                <p className="tc-pastrouver-p">
                    Our list of ingredients is not exhaustive. If you have a dietary supplement development project, please contact us for more information. Our sales team is ready to listen to your needs in terms of formulations adapted to specific health objectives.On request, we can provide you with technical data sheets, analysis bulletins and samples of raw materials.
                </p>
            </div>
        </div>
    );
}
